(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sparse-layer", [], factory);
	else if(typeof exports === 'object')
		exports["sparse-layer"] = factory();
	else
		root["sparse-layer"] = factory();
})(self, function() {
return 